export default __webpack_public_path__ + "static/media/laGarela.2b887501.png";